// extracted by mini-css-extract-plugin
export default {"NewRulesetButton":"InsightsBlank-module__NewRulesetButton__zLRL14n"};